import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Briefcase, Loader2, LogIn } from "lucide-react";
import consApi from "../../consultantApi";
import { Brand } from "../../components/Brand";

const inputCls = "w-full border border-gray-300 rounded-sm px-3 py-2.5 text-[14px] outline-none focus:border-[#16345c]";

const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return "Accesso non riuscito";
};

const ConsulenteLoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await consApi.post("/consulente/auth/login", { email, password });
      navigate("/consulente", { replace: true });
    } catch (err) { toast.error(errText(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#f4f6f9] flex items-center justify-center px-4" data-testid="consulente-login-page">
      <form onSubmit={submit} className="w-full max-w-[400px] bg-white border border-gray-200 rounded-xl shadow-sm p-8">
        <Link to="/" className="inline-block mb-6"><Brand dark={false} className="text-[22px]" /></Link>
        <div className="flex items-center gap-2 text-[#16345c] mb-1"><Briefcase size={18} /><h1 className="text-[20px] font-black">Area Consulente</h1></div>
        <p className="text-[13px] text-gray-500 mb-6">Accesso riservato ai consulenti del lavoro abilitati dal Superadmin.</p>
        <label className="block mb-3">
          <span className="block text-[12px] font-semibold text-gray-600 mb-1">Email</span>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="consulente-login-email" className={inputCls} />
        </label>
        <label className="block mb-5">
          <span className="block text-[12px] font-semibold text-gray-600 mb-1">Password</span>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="consulente-login-password" className={inputCls} />
        </label>
        <button type="submit" disabled={busy} data-testid="consulente-login-submit"
          className="w-full flex items-center justify-center gap-2 bg-[#16345c] hover:bg-[#0d1b2f] text-white text-[14px] font-bold py-2.5 rounded-sm transition-colors disabled:opacity-60">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <LogIn size={16} />} Accedi
        </button>
      </form>
    </div>
  );
};

export default ConsulenteLoginPage;
